import { useEffect } from 'react';
import { sectionAnchor, type ProjectSettingsSection } from './settingsSections';

/** `?section=`: land on that card once the project is in (smooth, or a jump under reduced motion). */
export function useScrollToSection(projectId: string | undefined, section: ProjectSettingsSection | undefined) {
  useEffect(() => {
    if (!projectId || !section) return;
    const t = setTimeout(() => {
      const el = document.getElementById(sectionAnchor(section));
      if (!el) return;
      const margin = Number.parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - margin), behavior: reduce ? 'auto' : 'smooth' });
    }, 60);
    return () => clearTimeout(t);
  }, [projectId, section]); // the id, not the object: every refetch makes a new project object
}
